import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';

const events = [
	EVENTS.SETTINGS_UPDATE,
	EVENTS.ERROR_PAGE,
	EVENTS.MODAL,
	EVENTS.BONUS_ROUND_STATE
];

class FastPlayController {
	constructor(vc, conf) {
		this.vc = vc.holder;
		this.config = conf;
		this.enabled = false;
		if (this.vc.getChildByName(this.config.btn)) {
			this.item = this.vc.getChildByName(this.config.btn);
			this.item.handler = this.handle.bind(this);
			this.item.setActive(GameConfigs.settings.fast_spin);
			this.checkBonus();
		} else {
			throw new Error(
				'FastPlayController failed init ' + JSON.stringify(this.config)
			);
		}
	}

	checkBonus() {
		if (GameConfigs.config.hasbonus) {
			this.item.interactive = false;
		} else {
			this.item.interactive = true;
			this.addEventListeners();
			window.addEventListener(EVENTS.BONUS_BUY, this, false);
		}
	}

	addEventListeners() {
		for (let i = 0; i < events.length; i++) {
			window.addEventListener(events[i], this, false);
		}
		if (
			GameConfigs.settings.keyboard_shortcuts &&
			!window.isMobile &&
			!window.isTablet
		) {
			this.enabled = true;
			window.addEventListener('keydown', this, false);
		}
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.SETTINGS_UPDATE:
				if (evt.detail.data.fast_spin !== undefined) {
					setTimeout(() => {
						this.item.setActive(evt.detail.data.fast_spin);
					}, 10);
				}
				if (evt.detail.data.keyboard_shortcuts !== undefined) {
					if (evt.detail.data.keyboard_shortcuts) {
						if (this.enabled) return;
						this.enabled = true;
						window.addEventListener('keydown', this, false);
					} else {
						this.enabled = false;
						window.removeEventListener('keydown', this, false);
					}
				}
				break;
			case EVENTS.BONUS_ROUND_STATE:
				if (evt.detail.state === 'started') {
					window.removeEventListener(EVENTS.BONUS_BUY, this, false);
					window.removeEventListener(EVENTS.BONUS_ROUND_STATE, this, false);
					this.removeListeners();
				}
				break;
			case EVENTS.BONUS_BUY:
				if (evt.detail.bonus) {
					// this.removeListeners();
					this.item.interactive = false;
				} else {
					this.item.interactive = true;
					// this.addEventListeners();
				}
				break;
			case EVENTS.ERROR_PAGE:
				if (evt.detail.error) {
					this.removeListeners();
					window.removeEventListener(EVENTS.BONUS_BUY, this, false);
				}
				break;
			case EVENTS.MODAL:
				if (!window.isMobile && !window.isTablet) return;
				if (
					evt.detail.modal === 'settings' ||
					evt.detail.modal === 'quest' ||
					evt.detail.modal === 'quest_claim' ||
					GameConfigs.bonusBuy
				) {
					this.item.interactive = false;
				} else this.item.interactive = true;
				break;
			case 'keydown':
				if (evt.keyCode === 70) this.handle();
				break;
			default:
				break;
		}
	}

	handle() {
		HELPERS.setSettings({
			fast_spin: !GameConfigs.settings.fast_spin
		});
	}

	removeListeners() {
		this.item.interactive = false;
		for (let i = 0; i < events.length; i++) {
			window.removeEventListener(events[i], this, false);
		}
		window.removeEventListener('keydown', this, false);
	}
}

export default FastPlayController;
